import { render, staticRenderFns } from "./SettingsCreateDialog.vue?vue&type=template&id=1bf0e8b6&"
import script from "./SettingsCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./SettingsCreateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports